// assets
import { CommentOutlined } from '@ant-design/icons';

// icons
const icons = {
  CommentOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'whatsapp',
  title: 'whatsapp',
  type: 'group',
  children: [
    {
      id: 'message',
      title: 'Message Bulk  ',
      type: 'item',
      url: '/message',
      icon: icons.CommentOutlined
    },
    {
      id: 'chat',
      title: 'Chat',
      type: 'item',
      url: '/chat',
      icon: icons.CommentOutlined
    }
  ]
};

export default pages;
